"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULTS = void 0;
const package_json_1 = require("../package.json");
exports.DEFAULTS = {
    apiBaseUrl: "https://api-v2.flipsidecrypto.xyz",
    ttlMinutes: 60,
    maxAgeMinutes: 0,
    cached: true,
    dataProvider: "flipside",
    dataSource: "snowflake-default",
    timeoutMinutes: 20,
    retryIntervalSeconds: 0.5,
    pageSize: 100000,
    pageNumber: 1,
    sdkPackage: "js",
    sdkVersion: package_json_1.version,
};
//# sourceMappingURL=defaults.js.map